import * as React from 'react';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import AlertTitle from '@mui/material/AlertTitle';

const CustomAlerts = ({ open, variant, severity, setOpen, title, message }) => {
  return (
    <Stack sx={{ width: '100%' }} spacing={1}>
      <Collapse in={open}>
        <Alert
          variant={variant}
          severity={severity}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mt: 1 }}
        >
          <AlertTitle>{title}</AlertTitle>
          <span>{message}</span>
        </Alert>
      </Collapse>
    </Stack>
  );
}

export default CustomAlerts;